module.exports = __webpack_public_path__ + "img/noq-map-pin-inactive.69cef304.svg";